const actTemplateValidationScheme = {
  scheduledDay: ['positiveNumber'],
  finTermGroupIds: ['oneFinTermRequired'],
  reportTotalExpression: ['required'],
  currency: ['required'],
  payoutPeriod: ['required'],
  reportFileNamePattern: ['forbiddenFileNameSymbols'],
  tempFileId: ['actTemplateFileRequired'],
  globalTemplateFileId: ['actTemplateFileRequired'],
  fileName: ['actTemplateFileFormat']
};
export default actTemplateValidationScheme;
